import { useEffect, useState } from 'react';
import useUserStore from '../Stores/UserStore';
import { translateText } from '../Services/GoogleTranslate';

/**
 * Translates the given English text based on logged-in user's language.
 * Subscribes to the top-level `appLanguage` primitive for reliable reactivity.
 */
export function useGoogleTranslate(baseText) {
  // Subscribe to a top-level primitive — guaranteed re-render on any language change
  const appLanguage = useUserStore((s) => s.appLanguage ?? 'en');

  const [translated, setTranslated] = useState(baseText);

  useEffect(() => {
    let cancelled = false;

    async function run() {
      const langCode = appLanguage || 'en';

      if (langCode === 'en') {
        if (!cancelled) setTranslated(baseText);
        return;
      }

      const result = await translateText(baseText, langCode);
      if (!cancelled) setTranslated(result);
    }

    run();
    return () => {
      cancelled = true;
    };
  }, [baseText, appLanguage]);

  return translated;
}
